import { useCallback, useEffect, useRef, useState } from 'react'
import Styles from './CSVUploadJourney.module.css';
import { ICONS } from '../ui-elements/Icon';
import { useDropzone } from "react-dropzone";
import { useRouter } from "next/router";
import GlobalApi from "src/modules/batchEditor/services/GlobalAPI";
import useToast from "@/hooks/useToast";
import { Button } from "@mui/material";
import { BULK_AI_TYPE } from "@/utils/toolsConstants";
import BatchEditorSuccessDialog from "@/modules/file-upload/batchEditorSucessDialog";
import SelectGenerationModel from './SelectGenerationModel';
import { aiTaskDisableAtom, batchEditorSelectedPresetAtom, fileCountAtom } from '../batchEditor/atoms';
import { useSelector } from 'react-redux';
import { useAtomValue, useSetAtom } from 'jotai';
import { EditorScreen } from '../batchEditor/BulkUploadEditor/constant';
import { setBulkUplodAIType } from '@/redux/reducers/file-upload.reducer';
import { dispatch } from '@/redux/store';
import { debounce } from 'lodash';
import GlobalAPI from 'src/modules/batchEditor/services/GlobalAPI';
import useComponentVisible from '@/hooks/useComponentVisible';

const CSVUploadJourney = ({setBatchCSVUploadJourney,isBulkAIType}) => {
    const [csvFile, setCSVFile] = useState();
    const [csvInstructionFile, setCSVInstructionFile] = useState();
    const [error, setError] = useState(null);
    const [csvInstructionError, setCSVInstructionError] = useState(null);
    const router = useRouter();
    const toast = useToast();
    const [uploading,setUploading] = useState(false);
    const [removeBackground,setRemoveBackground] = useState(false);
    const batchEditorSelectedPreset = useAtomValue(batchEditorSelectedPresetAtom);
    const [openFileUploadSuccessDialog, closeFileUploadSuccessDialog] = useState(false);
    const [openSelectionDialog, setOpenSelectionDialog] = useState(false);
    const setFileCount = useSetAtom(fileCountAtom);
    const { bulkUplodAIType} = useSelector(state => state.fileUpload);
    const aiTaskDisable = useAtomValue(aiTaskDisableAtom);
    const [selectedBrand,setSelectedBrand] = useState(null);
    const [searchBrandCTA,setSearchBrandCTA] = useState("");
    const [searchedList,setSearchedList] = useState([]);
    const [isLoading,setIsLoading] = useState(false);
    const [batchList,setBatchList] = useState([]);
    const [endReached, setEndReached] = useState(false);
    const { ref, isComponentVisible:showBrandList, setIsComponentVisible:setShowBrandList } = useComponentVisible(false);

    const fetchBrandListData = async (searchStr) => {
      try {
        setIsLoading(true);
        const response = await GlobalApi.getBrandList({skip:batchList?.length,limit:10,searchStr:searchStr});
        const seen = new Set();
        response.data?.data?.brandList?.length < 10 ? setEndReached(true) : setEndReached(false);
        const newList = [...batchList, ...(response.data?.data?.brandList || [])];
        const uniqueArray = newList.filter((item) => {
          if (seen.has(item._id)) {
            return false;
          }
          seen.add(item._id);
          return true;
        });
        setBatchList(uniqueArray);
        setIsLoading(false);
      } catch (err) {
        console.error(err);
        setIsLoading(false);
      }
    };

    const paginationHandler = debounce((e) => {

      if (
        e.target.scrollTop + e.target.clientHeight >=
        e.target.scrollHeight - 100
      ) {
        console.log("inside pagination now");
    
        if (!isLoading && !endReached) fetchBrandListData();
      }
    }, 100);
    
    useEffect(() => {
      fetchBrandListData();
    }, []);


      const onSearchBrandList = (value) => {
        setShowBrandList(true);
        setSearchBrandCTA(value);
        setBatchList([]);
        fetchBrandListData(value);
      };

    const saveProject = async(e) => {
        if(!csvFile)return;
        setFileCount(null);
        closeFileUploadSuccessDialog(true);
    };

    const selectionOptionHandler = (value) => {
        setRemoveBackground(value);
        setOpenSelectionDialog(true);
      };

    const submitHandler = async(selectionData) => {
        setUploading(true);
        try{
        const formData = new FormData();
        formData.append("file", csvFile);
        formData.append("uploadType", "csv");
        formData.append("marketplaceId",batchEditorSelectedPreset?.marketplace_id)
        bulkUplodAIType && formData.append("batchType",bulkUplodAIType);
        csvInstructionFile && formData.append("instructionFile", csvInstructionFile);
        formData.append("removeBackground",removeBackground);
        selectionData?.modelSelection && formData.append("modelSelection",JSON.stringify(selectionData?.modelSelection));
        if(!aiTaskDisable) {
          formData.append("priorityValue", 1);
        }
        // instructionType && formData.append("instructionType",instructionType);
        await GlobalAPI.uploadBulkJobCSV(formData).then((response)=>{
          if(response.data?.data?.batchId){
          let mode = EditorScreen.MAIN;
          if (aiTaskDisable) {
            mode = EditorScreen.PRODUCT_LIFESTYLE;
            router.replace({
              query: { mode, batchAI: response.data?.data?.batchId},
            });
          } else {
            router.push(`/dashboard/modelAI?batchId=${response.data?.data?.batchId}${selectedBrand?._id ? "&brandId=" + selectedBrand?._id : ""}`);
          }
          dispatch(setBulkUplodAIType(''));
        }else{
          toast.error("Something went wrong")
        }
        }).catch(error=>{
          const message = error.response?.data?.message?.csvError || error.response?.data?.errorResponse || 'CSV upload failed'
          toast.error(message)
          setUploading(false);
        })
        onCloseHandler();
        setUploading(false);
       }catch{(error)=>{
        console.error('CSV upload  error',error)
        setUploading(false);
       }}
      };

    const onDrop = useCallback(
        (acceptedFiles) => {
          if (!acceptedFiles?.length) return;
          if (acceptedFiles.length !== 1) {
            setError("Please upload exactly one CSV file");
          } else {
            setCSVFile(acceptedFiles[0]);
            setError(null);
          }
        },
        [setError]
      );

    const onDropInstruction = useCallback(
        (acceptedFiles) => {
          if (!acceptedFiles?.length) return;
          if (acceptedFiles.length !== 1) {
            setCSVInstructionError("Please upload exactly one CSV file");
          } else {
            setCSVInstructionFile(acceptedFiles[0]);
            setCSVInstructionError(null);
          }
        },
        [setCSVInstructionError]
      );

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { "text/csv": [".csv"] },
      });
    
      const { getRootProps:getInstructionRootProps, getInputProps:getInstructionInputProps, isDragActive:isDragActiveProps } = useDropzone({
        onDrop: onDropInstruction,
        accept: { "text/csv": [".csv"] },
      });

    const  handleDownloadSample = () => {
        const link = document.createElement('a');
        link.href = process.env.NEXT_PUBLIC_BULK_UPLOAD_CSV_URL;
        link.download = 'BulkUploadSample.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    
      const  handleInstructionDownloadSample = () => {
        const link = document.createElement('a');
        link.href = process.env.NEXT_PUBLIC_BULK_UPLOAD_INSTRUCTION_CSV_URL;
        link.download = 'BulkUploadSample.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

    
  return (
    <div className={Styles.container}>
    <div className={Styles.header}>
        <img src={ICONS.chevronDownDark} className={Styles.backIcon} onClick={()=>setBatchCSVUploadJourney(false)}/>
        CSV File
    </div>
    <div className={Styles.bottomSection}>
        <div className={Styles.viewBrandSection} ref={ref}>
            <p>Connect brand</p>
            <div className={Styles.viewBrandBtn} onClick={()=>setShowBrandList(prev=>!prev)}>
                <img src={ICONS.arrowDownCSV} className={Styles.viewBrandIcon} />
                <p className={Styles.viewBrandCta}>View brands</p>
            </div>
            {showBrandList && <div className={Styles.brandPopupContainer}>
                <div className={Styles.brandPopupHeader}>
                    <p>Connect Brands</p>
                    <div  className={Styles.searchContainer}>
                      <input type="search" placeholder='Search' value={searchBrandCTA} className={Styles.searchBrandpopup} onChange={e=>onSearchBrandList(e.target.value)} />
                    <img src={ICONS.lightSearchLens} className={Styles.searchIcon} />
                    </div>
                </div>
                <div className={Styles.brandPopupListContainer} onScroll={paginationHandler}>
                {searchedList?.length > 0 ? searchedList?.map((brand,index)=>(
                    <div key={index} className={`${Styles.brandOption} ${selectedBrand?.name === brand?.name && Styles.brandOptionActive}`} onClick={()=>{
                        setSelectedBrand(brand);
                        setSearchBrandCTA(brand?.name);
                        }}>
                    <p>{brand?.name}</p>
                    <img src={ICONS.tickIcon} className={Styles.brandTickIcon}/>
                    </div>
                )) :batchList?.map((brand, index) => (
                    <div key={index} className={`${Styles.brandOption} ${selectedBrand?.name === brand?.name && Styles.brandOptionActive}`} onClick={()=>{
                        setSelectedBrand(brand);
                        setSearchBrandCTA(brand?.name);
                        }}>
                    <p>{brand?.name}</p>
                    <img src={ICONS.tickIcon} className={Styles.brandTickIcon}/>
                    </div>
                    ))}
                {isLoading && <div className={Styles.brandOption} >
                    <p>Loading...</p>
                </div>}
                </div>
                <div className={Styles.brandPopupFooter}>
                    <button className={Styles.brandSelectionDone} onClick={()=>setShowBrandList(false)}>Done</button>
                </div>
                </div>}
        </div>
        <div  className={Styles.searchContainer}>
        <input type="search" placeholder={'|Search Brand'} value={searchBrandCTA} className={Styles.searchBrand} onChange={e=>onSearchBrandList(e.target.value)} />
        {!searchBrandCTA && <img src={ICONS.lightSearchLens} className={Styles.searchIcon} />}
        </div>
        <div className={Styles.divider}></div>
        <div {...getRootProps()} className={Styles.dropzoneStyles}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Drop the CSV file here ...</p>
          ) : (
            <p className={Styles.dropzoneStylesText}>
              {csvFile?.name ||
                `Drag 'n' drop a CSV file here`}
            </p>
          )}
          {error && <h3 className={Styles.errorMsg}>{error}</h3>}
        </div>
        {bulkUplodAIType !== BULK_AI_TYPE.BULK_UPLOAD_FACE_SWAP && 
        <div {...getInstructionRootProps()} className={Styles.dropzoneStyles}>
          <input {...getInstructionInputProps()} />
          {isDragActiveProps ? (
            <p>Add Instruction CSV file here ...</p>
          ) : (
            <p className={Styles.dropzoneStylesText}>
              {csvInstructionFile?.name ||
                `Drag 'n' drop Instruction CSV file here`}
            </p>
          )}
          {csvInstructionError && <h3 className={Styles.errorMsg}>{csvInstructionError}</h3>}
        </div>}
        <button className={`${Styles.continue} ${csvFile && Styles.continueActive}`} onClick={saveProject}>Continue</button>
        <div className={Styles.sampleBox}>
        <Button onClick={handleDownloadSample} sx={{width:"fit-content"}}  variant="text"> Project Sample </Button>
        {bulkUplodAIType !== BULK_AI_TYPE.BULK_UPLOAD_FACE_SWAP && <Button onClick={handleInstructionDownloadSample} sx={{width:"fit-content"}}  variant="text"> Instruction Sample </Button>}
      </div>
        <BatchEditorSuccessDialog 
        isBulkAIType={isBulkAIType}
        open={openFileUploadSuccessDialog}
        onClose={()=>closeFileUploadSuccessDialog(false)}
        saveProject={selectionOptionHandler}
      />
      <SelectGenerationModel
      open={openSelectionDialog}
      onClose={()=>setOpenSelectionDialog(false)}
      saveProject={submitHandler}
      applying={uploading}
       />
    </div>
  </div>
  )
}

export default CSVUploadJourney
